// Simple timezone helper centralizing conversions with moment-timezone
// Uses global window.moment to respect the project's current loading strategy.

export function isMomentTzReady() {
	return !!(window.moment && window.moment.tz && typeof window.moment.tz.guess === 'function');
}

export function getLocalZone() {
	// Prefer moment.tz.guess if available; fallback to Intl
	try {
		if (isMomentTzReady()) {
			return window.moment.tz.guess();
		}
	} catch (e) {}
	try {
		return Intl.DateTimeFormat().resolvedOptions().timeZone;
	} catch (e) {}
	return '';
}

export function resolveLocalZone(tzOverride = '') {
	if (tzOverride && String(tzOverride).indexOf('/') !== -1) {
		return tzOverride;
	}
	return getLocalZone();
}

/**
 * Espera a que moment + moment-timezone estén listos.
 * Si los scripts no están en el DOM, los inyecta (mismo patrón que prof-turns).
 */
export function ensureMomentTzReady(maxAttempts = 50, intervalMs = 100) {
	const waitReady = () => new Promise((resolve, reject) => {
		const tryOnce = (attempt) => {
			if (isMomentTzReady()) {
				resolve();
				return;
			}
			if (attempt > maxAttempts) {
				reject(new Error('moment-timezone no cargó a tiempo'));
				return;
			}
			setTimeout(() => tryOnce(attempt + 1), intervalMs);
		};
		tryOnce(0);
	});

	const ensureScript = (id, src) => new Promise((resolve, reject) => {
		let el = document.getElementById(id);
		if (el) {
			if ((id === 'momentScript' && window.moment) || (id === 'momentScriptYears' && window.moment && window.moment.tz)) {
				resolve();
				return;
			}
			el.addEventListener('load', () => resolve());
			el.addEventListener('error', () => reject(new Error('No se pudo cargar ' + id)));
			return;
		}
		el = document.createElement('script');
		el.id = id;
		el.src = src;
		el.async = false;
		el.onload = () => resolve();
		el.onerror = () => reject(new Error('No se pudo cargar ' + id));
		document.head.appendChild(el);
	});

	const momentEl = document.getElementById('momentScript');
	const tzEl = document.getElementById('momentScriptYears');
	if (momentEl && tzEl) {
		return waitReady();
	}
	return ensureScript('momentScript', 'https://cdn.jsdelivr.net/npm/moment@2.30.1/min/moment.min.js')
		.then(() => ensureScript('momentScriptYears', 'https://cdnjs.cloudflare.com/ajax/libs/moment-timezone/0.6.5/moment-timezone-with-data-10-year-range.min.js'))
		.then(() => waitReady());
}

export function convertToZone(dateTimeString, fromTimeZone, toTimeZone, inputFormat) {
	if (!window.moment || !window.moment.tz) {
		throw new Error('moment-timezone is not available on window');
	}
	const hasFormat = typeof inputFormat === 'string' && inputFormat.length > 0;
	const source = hasFormat
		? window.moment.tz(dateTimeString, inputFormat, fromTimeZone)
		: window.moment.tz(dateTimeString, fromTimeZone);
	return source.clone().tz(toTimeZone);
}

export function formatHourAtZone(dateTimeString, fromTimeZone, toTimeZone, inputFormat = 'YYYY-MM-DD HH:mm', outputFormat = 'HH:mm') {
	const converted = convertToZone(dateTimeString, fromTimeZone, toTimeZone, inputFormat);
	return converted.format(outputFormat);
}


